import angular from 'angular'
import ReportList from 'emun.report/report-list'
import QuickReportList from 'emun.report/quick-report-list'
import QuickReportPrompt from 'emun.report/quick-report-prompt'
import QuickReportPromptDirective from 'emun.report/quick-report-prompt.directive'
import PowerBIList from 'emun.report/powerbi-list'
import JobScheduler from "emun.report/job-scheduler/job-scheduler";
import JobSchedulerLog from "emun.report/job-scheduler/job-scheduler-log";

import scss from 'emun.report/report.scss'

const dependencies = ['emun.auth','webutils', 'webforms', 'webmodals', 'ui.router'];

export default angular.module('emun.report', dependencies)
  .component('reportList', ReportList)
  .component('quickReportList', QuickReportList)
	.component('powerbiList', PowerBIList)
  .directive('quickReportPrompt', QuickReportPromptDirective)
  .component('jobScheduler', JobScheduler)
  .component('jobSchedulerLog', JobSchedulerLog)
	.name;